import React from 'react'

import { DateObject } from '../../helpers/date'
import { Currency } from '../../types/currency'
import { AddCreditorsRequestInput } from '../../types/walletCreditor'
import StepThreePaymentTermAssignment from './steps/stepThreePaymentTermsAssignment'
import StepTwoCreditorsDetails from './steps/stepTwoCreditorsDetails'

interface StepContentProps {
  step: number
  creditorsInput: AddCreditorsRequestInput
  setcreditorsInput: React.Dispatch<
    React.SetStateAction<AddCreditorsRequestInput>
  >
  coveringRange: DateObject
  setcoveringRange: React.Dispatch<React.SetStateAction<DateObject>>
  sethasFinishedAssigning: React.Dispatch<React.SetStateAction<boolean>>
  currency: Currency
}

const StepContent: React.FC<StepContentProps> = ({
  step,
  setcreditorsInput,
  creditorsInput,
  coveringRange,
  setcoveringRange,
  sethasFinishedAssigning,
  currency
}) => {
  switch (step) {
    case 0:
      return (
        <StepTwoCreditorsDetails
          {...{
            setcreditorsInput,
            creditorsInput,
            currency
          }}
        />
      )
    case 1:
      return (
        <StepThreePaymentTermAssignment
          {...{
            setcreditorsInput,
            creditorsInput,
            coveringRange,
            setcoveringRange,
            sethasFinishedAssigning
          }}
        />
      )

    default:
      return <div>Unknown Step</div>
  }
}

export default StepContent
